import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError, catchError, map } from 'rxjs';
import { getApiEndpoint } from '@app/shared/utils/url.utils';
import { parseApiError } from '@app/shared/models/api/api-error.model';
import { FeaturedReviewModel } from '@app/shared/models/api/featured-review.model';
import { AkitaFirebaseQuery } from '@app/akita/firebase/state/firebase.query';

@Injectable({ providedIn: 'root' })
export class SearchVariantsApiService {
  private readonly http = inject(HttpClient);

  constructor(private readonly akitaFirebaseQuery: AkitaFirebaseQuery) {}

  public fetchFeaturedReviews(
    language?: string | null,
    model?: string | null,
    limit?: number | null
  ): Observable<Array<FeaturedReviewModel>> {
    const accessToken = this.akitaFirebaseQuery.accessToken || null;
    const apiUrl: string = getApiEndpoint('api/v2/product/reviews', true);

    let params = new HttpParams();
    if (model) {
      params = params.append('model', `${model || ''}`);
    }
    params = params.append('language', `${language || 'en'}`.toLowerCase());
    params = params.append('limit', limit || '800');

    let headers = {};
    if (accessToken) {
      headers = {
        Authorization: `Bearer ${accessToken}`,
      };
    }

    return this.http
      .get<any>(
        // Assemble the full API URL
        apiUrl,
        // Add the Options
        {
          responseType: 'json',
          headers: headers,
          params: params,
        }
      )
      .pipe(
        catchError((error: unknown) => throwError(() => parseApiError(error))),
        map((data) => [...(data.results || [])])
      );
  }
}
